import React from 'react'

export const Square=()=>(
  <svg width="80" height="80" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M48.066 61.627c6.628 0 10.087-16.79 10.087-23.418 0-6.627-5.025-9.209-11.652-9.209C39.874 29 24 42.507 24 49.135c0 6.627 17.439 12.492 24.066 12.492z" fillOpacity=".24" fill="#A0A6EE"/>
      <path d="M26 54l28-28" stroke="#838DEA" strokeWidth="2" strokeLinecap="square"/>
      <path d="M26 46l20-20M26 38l12-12M26 30l4-4M34 54l20-20M42 54l12-12" stroke="#767DE1" strokeWidth="2" strokeLinecap="square"/>
      <path d="M50 54l4-4" stroke="#838DEA" strokeWidth="2" strokeLinecap="square"/>
    </g>
  </svg>
)

export const BarGraph=()=>(
  <svg width="80" height="80" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M48.066 61.627c6.628 0 10.087-16.79 10.087-23.418 0-6.627-5.025-9.209-11.652-9.209C39.874 29 24 42.507 24 49.135c0 6.627 17.439 12.492 24.066 12.492z" fillOpacity=".24" fill="#75ABF3"/>
      <path d="M34 52V35M40 52V42M46 52V35M52 52V42M28 52V28" stroke="#4D8EF7" strokeWidth="2" strokeLinecap="square"/>
    </g>
  </svg>
)

export const TwoSquares=()=>(
  <svg width="80" height="80" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M48.066 61.627c6.628 0 10.087-16.79 10.087-23.418 0-6.627-5.025-9.209-11.652-9.209C39.874 29 24 42.507 24 49.135c0 6.627 17.439 12.492 24.066 12.492z" fillOpacity=".32" fill="#FF97AC"/>
      <path stroke="#FF6D8B" strokeWidth="2" strokeLinecap="square" d="M49 45h6V25H35v6M43 55h2v-2M25 53v2h2M27 35h-2v2"/>
      <path stroke="#FF6D8B" strokeWidth="2" strokeLinecap="square" d="M43 35h2v2M39 55h-2M33 55h-2M39 35h-2M33 35h-2M45 49v-2M25 49v-2M25 43v-2M45 43v-2"/>
    </g>
  </svg>
)

export const Connect=()=>(
  <svg width="80" height="80" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(24 25)" fill="none" fillRule="evenodd">
      <path d="M24.066 36.627c6.628 0 10.087-16.79 10.087-23.418C34.153 6.582 29.128 4 22.501 4 15.874 4 0 17.507 0 24.135c0 6.627 17.439 12.492 24.066 12.492z" fillOpacity=".32" fill="#A0EEE5"/>
      <circle stroke="#39D8C8" strokeWidth="2" strokeLinecap="square" cx="5" cy="4" r="4"/>
      <path stroke="#39D8C8" strokeWidth="2" strokeLinecap="square" d="M23 22h8v8h-8zM11 10l9 9"/>
    </g>
  </svg>
)

const Icon = {
  Square: Square,
  BarGraph: BarGraph,
  TwoSquares: TwoSquares,
  Connect: Connect,
}

const keys = Object.keys(Icon)

export const IconIndex=props=>{
  const {i} = props
  if (typeof(i)==='number'&&i>=0&&i<keys.length) {
    const I = Icon[keys[i]]
    return <I/>
  }
  return <Icon.Square />
}

export default Icon



// WEBPACK FOOTER //
// ./src/component/util/Icon.js